import React, { Component } from "react";
import Icon from "components/Icon";
import { Popover, Modal, Carousel } from "antd";
import { Img } from "components/Material";
import Badge from "components/Badge";
import UserEditModal from "@/routes/HomePage/components/navBarModal";
import StatusSettingModal from "@/routes/HomePage/components/statusSetting";
import { qryMessagesCountOfSchedule } from "@/routes/NavBar/AuditNotice/service";
import { qryNoReadMessageCount } from "@/routes/NavBar/StationNews/service";
import { qryAnnouncementList } from "@/routes/NavBar/SystemNotice/service";
import { forceHomepage } from "@/utils/common";
import $$ from "cmn-utils";
import cx from "classnames";
import "./style/index.less";

/**
 * 其本本局头部区域
 */
class NavBar extends Component {
  state = {
    visible: false,
    isVisible: false,
    messageVisible: false,
    statusSettingModalVisible: false, //状态设置模态框显隐
    totalAuditCount: 0,
    totalNoReadMessageCount: 0,
    authCodes: $$.getStore("authCodes"),
    annocuncementArray: [],
    annocuncementDom: <div className="carouselItem">{window.language["homepage.navbar.welcome"]}</div>
  };

  static defaultProps = {
    fixed: true,
    theme: "" //'bg-dark',
  };

  toggleFullScreen() {
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement &&
      !document.msFullscreenElement
    ) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.msRequestFullscreen) {
        document.documentElement.msRequestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
  }

  //模态框显示
  showModelHandler = e => {
    if (e) e.stopPropagation();
    this.setState({
      visible: true,
      isVisible: false
    });
  };

  /** 用户中心 */
  showUserCenter = e => {
    if (e) e.stopPropagation();
    window.location.href = window.contextPath + "#/userCenter";
    this.setState({
      isVisible: false
    });
  };

  /** 退出登录 */
  logout = e => {
    if (e) e.stopPropagation();
    this.setState({
      isVisible: false
    });
    const content = window.language["login.out.message"];
    Modal.confirm({
      className: "custom-modal",
      title: window.language["login.out.note"],
      okText: window.language["common.ok"],
      cancelText: window.language["common.cancel"],
      content,
      onOk: () => {
        $$.removeStore("user");
        $$.removeStore("token");
        $$.removeStore("authCodes");
        window.location.href = window.contextPath + "#/sign/login";
      },
      onCancel() { }
    });
  };

  /** 系统消息 */
  showStationNews = e => {
    if (e) e.stopPropagation();
    window.location.href = window.contextPath + "#/stationNews";
  };

  /** 审核通知 */
  showAuditNotice = e => {
    if (e) e.stopPropagation();
    window.location.href = window.contextPath + "#/auditNotice";
  };

  showSystemNotice = e => {
    if (e) e.stopPropagation();
    const user = $$.getStore("user");
    if (user) {
      let level = user.org.level;
      if (level === "1") {
        window.location.href = window.contextPath + "#/systemNotice";
      } else {
        return;
      }
    }
  };

  //隐藏模态框
  hideModelHandler = () => {
    this.setState({ visible: false });
  };

  //显示Popover
  handleVisibleChange = visible => {
    this.setState({
      isVisible: visible
    });
  };

  okHandler() {
    const { onOk } = this.props;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        onOk(values);
        this.hideModelHandler();
      }
    });
  }

  /** 异常状态设置模态框 */
  //展示异常状态设置模态框
  showStatusSettingModal = e => {
    if (e) e.stopPropagation();
    this.setState({
      statusSettingModalVisible: true,
      isVisible: false
    });
  };
  //隐藏异常状态设置模态框
  hideStatusSettingModal = () => {
    this.setState({
      statusSettingModalVisible: false
    });
  };
  //消息显示
  showMessageHandler = e => {
    if (e) e.stopPropagation();
    this.setState({
      messageVisible: true
    });
  };
  //消息隐藏
  hideMessageHandler = e => {
    if (e) e.stopPropagation();
    this.setState({
      messageVisible: false
    });
  };

  requestMessageNumber = user => {
    qryMessagesCountOfSchedule(user)
      .then(response => {
        if (response.code === "200") {
          this.setState({
            totalAuditCount: response.root
          });
        } else if (response.code === "100300") {
          this.clearGetMessageNumber();
        }
      })
      .catch();
  };

  requestNoReadMessageNumber = user => {
    qryNoReadMessageCount(user)
      .then(response => {
        if (response.code === "200") {
          this.setState({
            totalNoReadMessageCount: response.root
          });
        } else if (response.code === "100300") {
          this.clearGetMessageNumber();
        }
      })
      .catch();
  };

  componentDidMount() {
    this.getMessageNumber = window.setInterval(() => {
      const user = $$.getStore("user");
      if (user) {
        this.requestMessageNumber(user);
      } else {
        this.clearGetMessageNumber();
      }
    }, 30000);

    this.noReadMessageNumber = window.setInterval(() => {
      const user = $$.getStore("user");
      if (user) {
        this.requestNoReadMessageNumber(user);
      } else {
        this.clearNoReadMessageNumber();
      }
    }, 30000);

    this.getAnnouncementList();
  }

  componentWillUnmount() {
    this.clearGetMessageNumber();
    this.clearNoReadMessageNumber();
  }

  clearGetMessageNumber = () => {
    if (this.getMessageNumber) {
      window.clearInterval(this.getMessageNumber);
    }
  };

  clearNoReadMessageNumber = () => {
    if (this.noReadMessageNumber) {
      window.clearInterval(this.noReadMessageNumber);
    }
  };

  /**获取系统公告内容 */
  getAnnouncementList = () => {
    const user = $$.getStore("user");
    if (user) {
      let payload = {
        status: 1
      }
      qryAnnouncementList(payload)
        .then(response => {
          if (response.code === "200") {
            let root = response.root;
            let contentDom = root.map((val, index) => {
              return (
                <a key={val.id} className="carouselItem" href={val.linkAddress ? val.linkAddress : null} target="_blank">{val.content.substring(0, 20)}</a>
              )
                ;
            });
            if (contentDom.length !== 0) {
              this.setState({
                annocuncementDom: contentDom
              });
            }
          }
        })
        .catch();
    }
  };

  render() {
    const { fixed, theme, onCollapseLeftSide, collapsed, user } = this.props;
    const classnames = cx("navbar", {
      "navbar-fixed-top": !!fixed,
      "navbar-sm": collapsed,
      ["bg-" + theme]: !!theme
    });

    let loginUser = $$.getStore("user");
    if (!loginUser) {
      forceHomepage();
      return null;
    }

    let authCodes = $$.getStore("authCodes");
    if (!authCodes) {
      forceHomepage();
      return null;
    }

    const { logo, loginType } = user;
    let {
      totalAuditCount,
      totalNoReadMessageCount,
      annocuncementDom
    } = this.state;

    let src = "";
    if (!logo) {
      src = "assets/images/logo.png";
    } else {
      src = `${logo}`;
    }

    const userDropDownProps = {
      showUserCenter: this.showUserCenter,
      logout: this.logout
    };

    /** 用户设置参数 */
    const userModalProps = {
      visible: this.state.visible,
      hideModelHandler: this.hideModelHandler,
      showModelHandler: this.showModelHandler,
      user: user
    };

    /** 异常状态提醒参数 */
    const statusSettingModalProps = {
      statusSettingModalVisible: this.state.statusSettingModalVisible,
      hideStatusSettingModal: this.hideStatusSettingModal,
      user: user
    };

    let hello = window.language["homepage.navBar.hello"];
    return (
      <header className={classnames}>
        <div className="navbar-branding">
          <span className="navbar-brand">
            <Img src={src} />
          </span>
          <span className="toggle_sidemenu_l" onClick={onCollapseLeftSide}>
            <Icon type="lines" />
          </span>
        </div>
        <ul className="nav navbar-nav navbar-left clearfix">
          <Icon className="notice-o" />
          <div
            className="system-notice"
            style={{ cursor: "pointer" }}
          >
            <Carousel
              autoplay
              autoplaySpeed={4000}
              speed={700}
              vertical={true}
              dots={false}
            >
              {annocuncementDom}
            </Carousel>
          </div>
        </ul>
        <ul className="nav navbar-nav navbar-right clearfix">
          {authCodes["PROGRAM.PUBLISH.AUDIT"] ? (
            <li className="dropdown">
              <a
                className="dropdown-toggle"
                onClick={() => this.showAuditNotice()}
              >
                <Badge count={totalAuditCount}>
                  <Icon title={window.language["homepage.navBar.quickReview"]} className="audit-o ahover aactive" />
                </Badge>
              </a>
            </li>
          ) : (
            ""
          )}
          {
            <li>
              <a
                className="dropdown-toggle"
                onClick={() => this.showStationNews()}
              >
                <Badge count={totalNoReadMessageCount}>
                  <Icon title={window.language["homepage.navBar.systemInformation"]} className="message-o ahover aactive" />
                </Badge>
              </a>
            </li>
          }

          <li className="dropdown">
            <Popover
              placement="bottomRight"
              title={`${hello} ${user.nickname}`}
              overlayClassName={cx("navbar-popup", { [theme]: !!theme })}
              content={<UserDropDown {...userDropDownProps} />}
              visible={this.state.isVisible}
              onVisibleChange={this.handleVisibleChange}
              trigger="click"
            >
              <a className="dropdown-toggle">
                <Icon title={window.language["homepage.navBar.user"]} className="user-o ahover aactive" />
              </a>
            </Popover>
          </li>
        </ul>
        <UserEditModal {...userModalProps} />
        <StatusSettingModal {...statusSettingModalProps} />
      </header>
    );
  }
}

const UserDropDown = props => {
  let { showUserCenter, logout } = props;
  return (
    <ul className="dropdown-menu list-group dropdown-persist">
      <li className="list-group-item" onClick={showUserCenter}>
        <a className="animated animated-short fadeInUp">
          <Icon type="gear" /> {window.language["homepage.navBar.userCenter"]}
        </a>
      </li>
      <li className="list-group-item" onClick={logout}>
        <a className="animated animated-short fadeInUp">
          <Icon type="poweroff" /> {window.language["homepage.navBar.logout"]}
        </a>
      </li>
    </ul>
  );
};

export default NavBar;



// WEBPACK FOOTER //
// ./src/components/NavBar/NavBar.js